import template from './progress-ring.html';
import controller from './progress-ring.controller';

let ProgressRingComponent = {
    restrict: 'E',
    bindings: {
        current: '<',      // Current value
        total: '<',         // Total/target value
        size: '@',         // Size of the ring (default: 120)
        strokeWidth: '@',  // Stroke width (default: 8)
        color: '@',        // Progress color (default: #27ae60)
        bgColor: '@',      // Background color (default: #e0e0e0)
        showPercentage: '<', // Show percentage text (default: true)
        showValues: '<'     // Show current/total values (default: true)
    },
    template,
    controller
}

export default ProgressRingComponent;




// WEBPACK FOOTER //
// ./client/common/directives/progress-ring/progress-ring.component.js